<template>
    <MasterTemplate 
        title="ข้อมูลวัสดุสิ้นเปลือง" 
        :headers="headers" 
        :setData="setData"
        itemKey="consumableId"
        :getItemName="getItemName"
        :deleteData="deleteData"
        :insertData="insertData"
        :updateData="updateData"
        :listData="listData"
         maxDialogWidth="70%"
        >
        <template v-slot:formInput="{rules}" >
            <v-row>
                <v-col cols="4" >
                    <v-text-field outlined label="รหัสวัสดุสิ้นเปลือง" placeholder=" " autofocus maxlength="20" v-model="editedItem.consumableCode" :rules="[rules.required, chkCode]"></v-text-field>
                </v-col>
                <v-col cols="8" >
                    <v-text-field outlined placeholder=" " label="ชื่อวัสดุสิ้นเปลือง" maxlength="100" v-model="editedItem.consumableName" :rules="[rules.required]"></v-text-field>
                </v-col>
            </v-row>
              <v-row>
                  <v-col cols="4" >
                    <v-select
                        ref="supplierCode"
                        lazy-validation
                        v-model.lazy="editedItem.supplierCode"
                        :items="supplier"
                        label="ผู้ผลิต"
                        item-text="name"
                        item-value="value"
                        outlined placeholder=" "
                        v-bind:rules="myrulesSupplier"
                    ></v-select>
                </v-col>
                <v-col cols="4" >
                    <v-select
                        v-model="editedItem.consumableType"
                        :items="consumableTypes"
                        label="ประเภทวัสดุสิ้นเปลือง"
                        item-text="name"
                        item-value="value"
                        outlined placeholder=" "
                    ></v-select>
                </v-col>
                <v-col cols="4" v-if="editedItem.consumableType == 'C'">
                    <v-checkbox label="สูตรสี" v-model="editedItem.formular"></v-checkbox>
                </v-col>
            </v-row>

            <v-row >
                <v-col cols="4" >
                    <v-text-field type="number" ref="price" v-bind:rules="myrules" outlined placeholder=" "  label="ราคา (รับเข้า stock)" maxlength="6"  v-model="editedItem.price" ></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field outlined placeholder=" " label="หน่วยรับเข้า" maxlength="20" v-model="editedItem.unitOfPrice" ></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field type="number"  v-bind:rules="myrules"  outlined placeholder=" " label="ปริมาณของหน่วยรับเข้า" maxlength="6"  v-model="editedItem.size" ></v-text-field>
                </v-col>
            </v-row>

            <v-row >
                <v-col cols="4" >
                    <v-text-field type="number"  v-bind:rules="myrules" outlined placeholder=" " label="ราคาต่อหน่วย" maxlength="20" v-model="editedItem.unitPrice" ></v-text-field>
                </v-col>
                <v-col cols="4" >
                    <v-text-field  outlined placeholder=" " label="หน่วยย่อย" maxlength="20" v-model="editedItem.unitOfSize" ></v-text-field>
                </v-col>
            </v-row>

          

            <v-row v-if="editedItem.formular && editedItem.consumableType == 'C'">
                <v-col cols="12" >
                    <v-card >
                        <v-card-title>ส่วนผสม</v-card-title>
                        <v-divider></v-divider>
                        <v-form  style="margin-left:10px;margin-right:10px;">
                            <v-container>
                                <v-row>
                                    <v-col >
                                        <v-data-table
                                        :headers="subHeaders"
                                        :items="editedItem.colorList"
                                        item-key="consumableColorId"
                                        hide-default-footer
                                        :items-per-page="50"
                                        >
                                        <template v-slot:top>
                                            <v-dialog v-model="subDialog" max-width="600px" persistent>
                                                <template v-slot:activator="{ on }" >
                                                    <v-spacer></v-spacer><v-btn ref="btnAdd"  color="primary" dark class="mb-2" v-on="on">เพิ่ม</v-btn>
                                                </template>
                                                <v-container>
                                                    <v-form ref="subForm" lazy-validation>
                                                        <v-card >
                                                        <v-card-title>เพิ่มสูตรสี </v-card-title>
                                                        <v-divider></v-divider>
                                                        <v-card-text>
                                                            <v-row>
                                                                <v-col cols="5">
                                                                    <v-autocomplete
                                                                        v-model="selectedColor"
                                                                        label="สี"
                                                                        :items="consumableColor"
                                                                        item-text="display"
                                                                        item-value="consumableCode"
                                                                        :rules="[subRules.required]"
                                                                        return-object
                                                                        outlined placeholder=" "
                                                                    >
                                                                    </v-autocomplete>
                                                                </v-col>
                                                                <v-col cols="5">
                                                                    <v-text-field type="number" outlined placeholder=" " label="จำนวน" maxlength="6"  v-model="colors.qty" :rules="[rules.required]" ></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="blue darken-1" text @click="closeSubItem">ยกเลิก</v-btn>
                                                        <v-btn color="blue darken-1" text @click="addSubItem" v-if="selectedColor">ตกลง</v-btn>
                                                    </v-card-actions>
                                                    </v-card>
                                                    </v-form>
                                                    
                                                </v-container>
                                            </v-dialog>
                                        </template>
                                        <template v-slot:[`item.action`]="{ item }">
                                            <!-- <v-icon
                                                v-if="item.consumableColorId <= 0"
                                                small
                                                @click="editSubItem(item)"
                                            > -->
                                            <v-icon
                                                small
                                                @click="editSubItem(item)"
                                            >
                                                edit
                                            </v-icon>
                                            <v-icon
                                                small
                                                @click="deleteSubItem(item)"
                                            >
                                                delete
                                            </v-icon>
                                        </template>
                                    </v-data-table>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="text-left"></v-col>
                                    <v-col class="text-left"></v-col>
                                    <v-col class="text-center"><h3><label > รวม</label></h3></v-col>
                                    <v-col class="text-center"><label v-text="sum.qtyDisplay"> </label></v-col>
                                    <v-col class="text-center"><label v-text="sum.unitPriceDisplay"> </label></v-col>
                                    <v-col class="text-center"><label v-text="sum.totalDisplay"> </label></v-col>
                                    <v-col class="text-left"></v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </MasterTemplate>
</template>

<script>
/* eslint-disable */
    import MasterTemplate from '@/components/MasterTemplate'
    import ConsumableAPI from '@/api/master/consumable-api.js'
    import {listDropdownSupplier, listDropdownConsumableType, listDropdownConsumableColor} from '@/api/common/dropdown-api.js'
    import numeral from 'numeral'

export default {
    name: 'Consumable',
    components: {
        MasterTemplate
    },
    computed: {
        chkCode() {
            if (this.isDup == true) return 'รหัสผู้ผลิตซ้ำ';
            return true;
        },
        myrules(vm) {
            if (this.editedItem.formular && this.editedItem.consumableType == 'C') {
                this.isFormular = true;
                return [];
            } else {
                this.isFormular = false;
                return [this.subRules.requireValue];
            }
        },
        myrulesSupplier(){
            this.ret = [];
            if (this.isFormular) {
                this.ret =  [this.subRules.requireSupplierCode];
                this.onSupplierCodeChange();
            } 
            return this.ret;
        }
    },
    watch: {
        'editedItem.colorList': {
            handler: function(newVal) {
                this.sum = Object.assign({}, this.sumDefault);
                newVal.forEach(o => {
                    this.sum.qty += parseFloat(o.qty);
                    this.sum.unitPrice += parseFloat(o.unitPrice);
                    this.sum.total += parseFloat(o.total);

                    this.sum.qtyDisplay = numeral(this.sum.qty).format('0,0.00');
                    this.sum.unitPriceDisplay = numeral(this.sum.unitPrice).format('0,0.00');
                    this.sum.totalDisplay = numeral(this.sum.total).format('0,0.00');
                });
            },
            deep: true
        },
        'editedItem.consumableCode': function(newVal) {
            if (!this.editedItem.consumableId) {
                this.editedItem.consumableId = '-1';
            }
            
            if (newVal && this.editedItem.consumableId) {
                ConsumableAPI.isExistConsumableCode(newVal, this.editedItem.consumableId).then(response => {
                    this.isDup = response;
                }).catch(() => {
                    this.isDup = false;
                });
            }
        },
        subDialog(value) {
            if (value) {
                if (!this.$refs.supplierCode.validate()) {
                    return;
                }
                listDropdownConsumableColor(this.editedItem.supplierCode).then(rs => {
                    this.consumableColor = Object.assign([], this.defaultItem);
                    rs.data.forEach((v, i) => {
                        if (this.editedItem.colorList && this.editedItem.colorList.length > 0) {                            
                            let color = this.editedItem.colorList.find(c => {
                                return c.consumableColorCode == v.value;
                            });
                            if (!color) {
                                this.consumableColor.push(v);
                            }
                        } else {
                            this.consumableColor.push(v);
                        }
                    });
                });
            }
        }
    },
    data: () => ({
        isFormular: false,
        subDialog: false,
        isDup: false,
        headers: [
            {text: 'รหัสวัสดุสิ้นเปลือง', value: 'consumableCode'},
            {text: 'ชื่อวัสดุสิ้นเปลือง', value: 'consumableName'},
            {text: 'ราคา', value: 'price'},
            {text: 'หน่วย', value: 'unitOfPrice'},
            {text: 'ประเภทวัสดุสิ้นเปลือง', value: 'consumableTypeDesc'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        subHeaders: [
            {text: 'รหัสสี', value: 'consumableColorCode'},
            {text: 'ชื่อสี', value: 'consumableColorName'},
            {text: 'จำนวน', value: 'qty'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay'},
            {text: 'รวม', value: 'totalDisplay'},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        sum: {
            qty: 0,
            unitPrice: 0,
            total: 0
        },
        sumDefault: {
            qty: 0,
            unitPrice: 0,
            total: 0
        },
        editedItem: {
            consumableId: '-1',
            consumableCode: '',
            consumableName: '',
            price: 0,
            unitPrice: '',
            size: 0,
            unitSize: '',
            distributor: '',
            supplierCode: '',
            consumableType: '',
            formular: false,
            colorList: []
        },
        defaultItem: {
            consumableId: '-1',
            price: 0,
            size: 0,
            consumableType: '',
            formular: false,
            colorList: []
        },
        supplier: [],
        consumableTypes: [],
        consumableColor: [],
        colors: {
            consumableColorCode: '',
            consumableColorName: '',
            qty: 0,
            unitPrice: 0,
            total: 0
        },
        editSubItemIndex: -1,
        selectedColor: {},
        subRules: {
            requireValue: value => {
                return  value ? true : 'Required.';
            },
            required: value => {
                return value? value.consumableCode? true:'Required.': 'Required.';
            },
            requireSupplierCode: value => {
                return  value ? true : "กรุณาเลือก ผู้ผลิด เพื่อเพิ่มสูตรสี";
            }
        }
    }),
    methods: {
        listData() {
            return ConsumableAPI.listConsumable();
        },
        deleteData(item) {
            return ConsumableAPI.deleteConsumable(item.consumableId);
        },
        insertData() {
            if (this.isFormular && this.editedItem.colorList.length == 0) {
                this.$swal.fire({
                    title: 'Warning',
                    text: 'กรุณาเพิ่มสูตรสี',
                    icon: 'warning'
                });
                
                return new Promise((resolve, reject) => {
                    reject("กรุณาเพิ่มสูตรสี");
                });
            }
            return ConsumableAPI.insertConsumable(this.editedItem);
        },
        updateData() {
            return ConsumableAPI.updateConsumable(this.editedItem);
        },
        getItemName(item) {
            return item.consumableName;
        },
        setData(item) {
            if (item.consumableId && item.consumableId != -1) {
                ConsumableAPI.getConsumable(item.consumableId).then(rs => {
                    this.editedItem = rs;
                    this.sum = Object.assign({}, this.sumDefault);
                    if (!this.editedItem.colorList) {
                        this.editedItem.colorList = Object.assign([], []);
                    } else {
                        this.editedItem.colorList.forEach(o => {
                            o.unitPriceDisplay = numeral(o.unitPrice).format('0,0.00');
                            o.totalDisplay = numeral(o.total).format('0,0.00');
                        });
                    }
                    
                });
            } else {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedItem.colorList = Object.assign([], []);
            }
        },
        addSubItem() {
            if (!this.$refs.subForm.validate()) {
                return;
            }
            this.colors.consumableColorCode = this.selectedColor.consumableCode;
            this.colors.consumableColorName = this.selectedColor.consumableName;
            this.colors.unitPrice = this.selectedColor.unitPrice;
            this.colors.unitPriceDisplay = numeral(this.colors.unitPrice).format('0,0.00');
            this.colors.total = this.colors.qty * this.colors.unitPrice;
            this.colors.totalDisplay = numeral(this.colors.total).format('0,0.00');
            if (this.editSubItemIndex == -1) {
               // this.colors.consumableColorId = -1;
                this.editedItem.colorList.push(this.colors);
            } else {
                Object.assign(this.editedItem.colorList[this.editSubItemIndex], this.colors);
            } 
            
            this.colors = Object.assign({}, {});
            this.selectedColor = Object.assign({}, {});
            this.editSubItemIndex = -1;
            this.subDialog = false;
        },
        editSubItem(subItem) {
            this.selectedColor = Object.assign({}, subItem);
            this.colors.qty = subItem.qty;
            this.editSubItemIndex = this.editedItem.colorList.indexOf(subItem);
            this.subDialog = true;
            
            this.selectedColor.consumableCode = subItem.consumableColorCode;
            this.selectedColor.consumableName = subItem.consumableColorName;
            
        },
        deleteSubItem(subItem) {
             var result = confirm("ต้องการลบข้อมูลนี้หรือไม่?");
            if (result) {
                let index = this.editedItem.colorList.indexOf(subItem);
                this.editedItem.colorList.splice(index, 1);
            }
        },
        closeSubItem() {
            this.editSubItemIndex = -1;
            this.colors = Object.assign({}, {});
            this.colors.qty = 0;
            this.selectedColor = Object.assign({}, {});
            this.subDialog = false;
        },
        onSupplierCodeChange() {
            this.$nextTick(() => {
                this.$refs.supplierCode.focus();
                this.$refs.supplierCode.validate();
                this.$refs.price.focus();
            });
        }
    },
    mounted() {
        listDropdownSupplier().then(rs => {
            this.supplier = rs.data
        });
        listDropdownConsumableType().then(rs => {
            this.consumableTypes = rs
        });
    }
}
</script>